<script setup lang="ts">
import useClipboard from 'vue-clipboard3'
import { ref, nextTick, watch } from 'vue'
import { Data } from '@/stores/data'

// import { MdEditor } from 'md-editor-v3';
// import 'md-editor-v3/lib/style.css';
import { MdPreview, MdCatalog } from 'md-editor-v3'
// preview.css相比style.css少了编辑器那部分样式
import 'md-editor-v3/lib/preview.css'
import { Utill } from '@/stores/Utill'
import { ElementTip } from '@/stores/ElementTip'
import { HTTP } from '@/network/http'

import { jiaoanFilterKey } from '@/stores/StaticText'
import CommentsMessageItem from '@/components/Application/XhComponents/item/CommentsMessageItem.vue'
import emitter from '@/stores/mitt'

// import sanitizeHtml from 'sanitize-html';
// import renderMathInElement from 'katex/contrib/auto-render/auto-render'
const scrollElement = document.documentElement

const $emit = defineEmits(['showFeedback', 'VideoanginAnswer', 'addActionCard', 'clickExampleCard'])
let initialIndex = ref(0);
let isShowImgBtns = ref<number | null>(null);
const captureDiv = ref(null)
let timeIndex: any = null
const resultList = ref<any[]>([])
// const sanitize = (html) => sanitizeHtml(html);
let isShowBigImg = ref(false);
interface BackListType {
  text: string
  isSelected: boolean
  id: string
}
//错误反馈
const backList = ref<BackListType[]>([
  { text: '回答有误不准确', isSelected: false, id: '1' },
  { text: '产品功能不完善', isSelected: false, id: '2' },
  { text: '回答存在不当言论', isSelected: false, id: '3' }
])

//导出文档按钮文字
enum loadStateText {
  '下载',
  ''
}
let loadState = ref(0) //下载文档状态和loadStateText一一对应
let isButtonDisabled = ref(false)
let textareaData = ref() //输入的内容
let isShowFeedBack = ref(false) //是否显示反馈面板
let isCanDownLoade = ref(false)
// let csStr = ['111111111111111', '2222222222222222', '33333333333333333'];
let strIndex = ref(1)
//父级入参
let def = defineProps({
  backText: {
    type: [String, Array],
    default: ''
  },
  isCopy: {
    //可以copy证明是否已经显示完成
    type: [Boolean, Array],
    default: false
  },
  isFeedback: {
    type: Boolean,
    default: false
  },
  isHtml: {
    type: Boolean,
    default: false
  },
  problem: {
    type: [String, Object],
    default: ''
  },
  messageKey: {
    type: String,
    default: ''
  },
  isLast: {
    type: Boolean,
    default: false
  },
  isShowJiaoanBtn: {
    type: Boolean,
    default: false
  },
  loadingType: {
    type: Array,
    default: null
  },
  otherData: {
    type: Object,
    defaule: {}
  }
})

console.log(typeof def.backText)
console.log(def.backText)

// 点击复制
function touchCopy(item: any) {
  emitter.emit('insert-link', item)
  // emitter.emit('insert-Document',getCurrText())
}
function clickImg(item: any) {
  emitter.emit('insert-img', item.url)

}
function openUlr(item: any) {
  window.open(item.url)
}
function anginAnswer() {
  $emit('VideoanginAnswer', { 'id': def.messageKey, 'problem': def.problem });

}
function closePreview() {
  isShowBigImg.value = false;
  console.log(">>>2222>")
}
function openImgViewer(index: number) {
  isShowBigImg.value = true;
  initialIndex.value = index;
}
function showOverlay(index: number) {
  isShowImgBtns.value = index;
}
function hideOverlay(index: number) {
  isShowImgBtns.value = null;
}
</script>

<template>
  <div class="mess">
    <div class="mess-ctr">
      <div class="avatar">
        <img class="rounded-circle" src="@/assets/xh-icon-new.png" alt="avatar" />
      </div>
      <div class="cro-new">
        <img class="cro-img" src="@/assets/cro.svg" alt="" />
      </div>
      <div class="text-ctr">
        <div class="nr-ctr"
          v-if="((otherData.shiPines && otherData.shiPines.length > 0) || (otherData.tuWenes && otherData.tuWenes.length > 0))">
          <div class="video-ctr" v-if="otherData.shiPines && otherData.shiPines.length > 0">
            <p class="search-tip">小鸿为您推荐以下视频：</p>
            <div v-for="(item, index) in otherData.shiPines" :key="index" class="list-item" @click="openUlr(item)">
              <div class="name-ctr">{{ item.name }}</div>
              <div class="site-ctr">
                <div class="site-name-ctr">
                  <img src="../../../../assets/tu-icon.svg" />
                  <div class="site-name font-ten">
                    {{ item.siteName }}
                  </div>
                </div>
                <div class="cr-btn" @click.stop="touchCopy(item)">插入链接</div>
              </div>
            </div>
            <p class="content-tip">以上内容来自网络，请仔细甄别</p>
          </div>
          <div class="video-ctr" v-if="otherData.tuWenes && otherData.tuWenes.length > 0">
            <p class="search-tip">小鸿为您推荐以下图片：</p>
            <div class="list-ctr">
              <div v-for="(item, index) in otherData.tuWenes" :key="index" class="list-img-item"
                @mouseenter="showOverlay(index)" @mouseleave="hideOverlay(index)">
                <!-- -->
                <div class="img-btns" v-if="isShowImgBtns == index">
                  <div class="img-btn" @click="openImgViewer(index)">查看大图</div>
                  <div class="img-btn" @click.stop="clickImg(item)">插入文档</div>
                </div>
                <el-image style="width: 100%; height: 100%" :src="item.url" :fit="'contain'" />
              </div>
              <el-image-viewer v-if="isShowBigImg" hide-on-click-modal :initial-index="initialIndex" teleported
                @close="closePreview" style="z-index: 3000" :url-list="otherData.tuWenes.map(item => item.url)" />
            </div>
            <p class="content-tip">以上内容来自网络，请仔细甄别</p>
          </div>
          <div class="shuxin-btn" @click="anginAnswer" v-if="isLast">
            <img src="@/assets/shuaxin.svg">
            换一换
          </div>
        </div>
        <div v-else class="no-data">
          小鸿不太理解，换一个话术问问我吧
        </div>


      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.nr-ctr {
  width: 100%;
  // height: 
}

.content-tip {
  font-size: 10px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ADADAD;
  text-align: center;
  margin: 8px 0;
}

.img-btns {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}

.img-btn:hover {
  background: #F7F7F7;
}

.img-btn {
  color: #4E5969;
  padding: 3px 12px;
  background: #FFFFFF;
  border-radius: 45px;
  cursor: pointer;

}

.shuxin-btn:hover {
  background: #F7F7F7;
}

.shuxin-btn {
  border: 1px solid #E5E6EB;
  width: 100%;
  height: 31px;
  color: #4E5969;
  border-radius: 45px;
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.list-ctr {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: space-between;
}

.list-img-item {
  width: 124px;
  height: 124px;
  border-radius: 8px;
  opacity: 1;
  background: #F7F7F7;
  box-sizing: border-box;
  border: 1px solid #EDEDED;
  overflow: hidden;
  position: relative;
}

.cr-btn {
  border-radius: 45px;
  padding: 5px 12px;
  color: #485cec;
  font-size: 12px;
  background: #ffffff;
}

.cr-btn:hover {
  background: #e2e5fc;
}

.search-tip {
  margin-bottom: 12px;
}

.site-ctr {
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
}

.site-name-ctr {
  display: flex;
  align-items: flex-end;
  gap: 6px;
}

.site-name {
  color: #a8abb2;
  overflow: hidden;
  /*内容超出后隐藏*/
  text-overflow: ellipsis;
  /*超出内容显示为省略号*/
  white-space: nowrap;
  /*文本不进行换行*/
  width: 100px;
}

.name-ctr {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #040a39;
  line-height: 22px;
}

.video-name {
  font-size: 13px;
  font-weight: normal;

  letter-spacing: 0px;
  color: #040a39;
}

.video-site {}

.text-title {
  border-radius: 8px;
  opacity: 1;
  background: #f7f8fa;
  line-height: 40px;
  padding-left: 10px;
  color: #59adec;
  font-weight: 500;
  white-space: nowrap;
}

.similar-ctr {
  border-radius: 16px;
  opacity: 1;

  background: #ffffff;
  padding: 12px;
  margin-top: 8px;
  width: 279px;
}

.jiantou-ctr {
  width: 20px;
  height: 20px;
  background: #e5e6eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-text {
  width: 76%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-item {
  /* display: flex; */
  border-radius: 8px;
  background: #f7f8fa;
  align-items: center;
  justify-content: space-around;
  margin-top: 8px;
  cursor: pointer;
  padding: 8px;
  /* line-height: 42px; */
}

.answer-loading-ctr {
  font-size: 12px;
  position: absolute;
}

.show-opacity {
  opacity: 1;
}

.hide-opacity {
  opacity: 0;
}

/* .go-on-ico{

} */
.xh-up-move {
  -webkit-animation: slide-up 0.6s ease 0.7s forwards;
  animation: slide-up 0.6s ease 0.7s forwards;
  opacity: 0;
  width: calc(100% - 72px);
  margin-left: 41px;
}

@-webkit-keyframes slide-up {
  0% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

.xh-answer-over {
  margin-left: 41px;
  margin-top: 4px;
  display: flex;
  -webkit-animation: fadeInAndOut 0.4s ease 0.4s forwards;
  animation: fadeInAndOut 0.4s ease 0.4s forwards;
}

@keyframes fadeInAndOut {
  0% {
    opacity: 1;
    /* 开始时透明度为 0 */
  }

  100% {
    opacity: 0;
    /* 结束时透明度为 0，消失状态 */
    display: none;
    /* 可选：在动画结束后隐藏 div */
  }
}

@-webkit-keyframes fadeInAndOut {
  0% {
    opacity: 1;
    /* 开始时透明度为 0 */
  }

  100% {
    opacity: 0;
    /* 结束时透明度为 0，消失状态 */
    display: none;
    /* 可选：在动画结束后隐藏 div */
  }
}

.xh-answer-loading {
  margin-left: 41px;
  margin-top: 4px;
  display: flex;
  align-items: baseline;
}

.downTipBtn {
  line-height: 24px;
  border-radius: 8px;
  opacity: 1;
  background: #e5e6eb;
  text-align: center;
  font-size: 12px;
  color: #4e5969;
  margin-top: 8px;
  display: flex;
  /* align-items: center; */
  flex-wrap: nowrap;
  justify-content: center;
}

@keyframes opacityAnimation {

  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

.cs-move {
  animation: opacityAnimation 0.6s cubic-bezier(1, -0.09, 0, 1.12) infinite;
}

.left-jiantou {
  transform: rotate(180deg);
}

.jiantou-ico {
  /* transform: rotate(180deg); */
  width: 4px;
  /* margin-left: 0.12rem; */
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.switch-ctr {
  display: flex;
  font-size: 12px;
  gap: 4px;
  margin-top: 10px;
  line-height: 14px;
  align-items: flex-start;
  margin-bottom: 8px;
}

.switch-btn {
  /* font-size: 0.18rem;
      text-align: left;
      cursor: pointer; */
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
}

:deep(.el-textarea .el-input__count) {
  bottom: -18px;
  right: 0px;
}

.backBtn {
  color: #59adec;
  text-align: center;
  width: 100%;
  line-height: 36px;
  font-size: 14px;
  cursor: pointer;
}

.inputCon {
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  margin-top: 9px;
}

.text-ctr.feedbackList {
  /* max-width: 5rem; */
  /* min-width: 260Px; */
  /* width: calc(100% - var(--rate-width) - 16Px); */
  width: 300px;
  margin-left: 41px;
  margin-top: 10px;
  padding: 0;
}

.backListItem {
  margin-top: 9px;
  padding: 4px 12px;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.backListItem.backListItemSelend {
  color: #59adec;
  border: 1px solid #59adec;
}

.seceletList {
  width: 100%;
  box-sizing: border-box;
  /* height: 100%; */
  padding: 8px 16px 3px 16px;
  /* border-top: 1px solid #F2F2F2; */
  border-bottom: 1px solid #f2f2f2;
}

.feedbackList .title {
  font-size: 14px;
  font-weight: 600;
}

.feedback .btn.goodSelecten {
  background: #59adec;
}

.feedback {
  display: flex;
  flex-direction: column-reverse;
  margin-left: 4px;
}

.feedback .btn {
  background-color: #fff;
  padding: 6px;
  border-radius: 50%;
  margin-top: 4px;
  cursor: pointer;
  overflow: hidden;
  min-height: 0;
}

.feedback .btn:last-child {
  margin-top: 0;
}

.feedback .btn img {
  display: block;
  height: 14px;
  width: 14px;
  min-width: 14px;
}

.mess {
  padding: 0 0 16px 0;
  max-width: 95%;
  -webkit-animation: msgLeft 0.5s ease-in-out;
  animation: msgLeft 0.5s ease-in-out;
}

.copyctr {
  display: flex;
  justify-content: flex-end;
  /* padding-bottom: 0.06rem; */
  border-top: 1px solid #f2f2f2;
  padding-top: 10px;
  margin-top: 2px;
}

.copyBtn {
  cursor: pointer;
  background: #fff;
  color: #000;

  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 100px;
  line-height: 20px;
  border: 1px solid #f2f2f2;
  width: 126px;
  font-size: 14px;
  font-weight: 350;
  padding: 6px 35px;

  box-sizing: border-box;
}

.copyBtn img {
  width: 12px;
  margin-right: 2px;
}

.insertBtn {
  background: #5570f1;
  color: #ffffff;
}

.isButtonDisabledClass {
  opacity: 0.7;
  pointer-events: none;
}

.loadingCLass img {
  -webkit-animation: preloader-spin 1s steps(12, end) infinite;
  animation: preloader-spin 1s steps(12, end) infinite;
  /* transform: translateZ(0); */
}

@keyframes preloader-spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes preloader-spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.mess-ctr {
  display: flex;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 32px;
  min-height: 26px;
  border-radius: 30px;
  overflow: hidden;

  height: 26px;
  width: 32px;
  flex-shrink: 0;
}

.text-ctr {
  background-color: #fff;
  padding: 10px 12px;
  border-radius: 0 20px 20px 20px;
  font-weight: normal;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  width: 279px;
  display: flex;
  flex-direction: column;
}

.cro {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  transform: rotate(270deg);
}

.cro_left_top {
  background: linear-gradient(180deg, #f3f3f6 0%, #eaedf6 100%);
  border-radius: 0 0 90% 0;
  /* border-bottom: 1px solid #f5f6fa; */
  /* border-right: 2px solid #f5f6fa; */
  width: 100%;
  height: 100%;
}

.cro-new {
  display: flex;
  justify-content: start;
  width: 8px;
  height: 8px;
}

.cro-img {
  width: 8px;
  height: 8px;
}

.video-item {
  background: #f6f6fb;
  border-radius: 12px;
  margin: 8px 6px;
}

.video-title {
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;

  font-variation-settings: 'wght' 400;
  color: #86909c;
}

.video-name {
  font-size: 13px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: #040a39;
}

.video-site {
  font-size: 10px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  width: 120px;
  font-variation-settings: 'wght' 400;
  /* Light/中性色 Neutral/Text/Placeholder */
  color: #a8abb2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-line2 {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.insertLinkBtn {
  width: 72px;
  height: 24px;
  background: #ffffff;
  border-radius: 256px;
  margin-right: 8px;
}
</style>
